<div [class]="tabStyleClass">
    <p-tabs
        [value]="activeItem?.label || items[0]?.label"
        [attr.sera-read-only]="readOnly ? '' : null"
        [class]="isTabHolderButtons ? 'tab__holder__button__menu ' + styleClass : styleClass"
        (valueChange)="onTabChange($any($event))">
        <p-tablist>
            <p-tab
                *ngFor="let item of items"
                [value]="item.label"
                [disabled]="item.disabled">
                {{ item.label! | translate }}
                <sera-items-count
                    *ngIf="$any(item).itemCounter"
                    styleClass="item-count item-count--blue workstock-sub-counters"
                    [itemsCount]="$any(item).itemCounterValue | async"
                    [loading]="($any(item).itemCounterValue | async) === undefined">
                </sera-items-count>
                <i
                    *ngIf="isToHaveCloseIcon"
                    class="ci ci-close"
                    (click)="$event.stopPropagation(); closeIconEvent.emit(item)"></i>
            </p-tab>
        </p-tablist>
    </p-tabs>
</div>
<router-outlet></router-outlet>
